import React from "react";

export default function HowThisWorks({ steps, testid = "how-this-works" }) {
    return (
        <div className="bg-stone-50 border border-stone-200 rounded-xl p-6 max-w-3xl" data-testid={testid}>
            <div className="text-[11px] uppercase tracking-[0.25em] text-stone-500 mb-4">
                How this works
            </div>
            <ol className="space-y-4">
                {steps.map((step, i) => (
                    <li key={i} className="flex gap-3">
                        <div className="w-7 h-7 rounded-full bg-orchid-700 text-white text-xs font-semibold flex items-center justify-center shrink-0">
                            {i + 1}
                        </div>
                        <div className="text-sm text-stone-700 leading-relaxed pt-0.5">{step}</div>
                    </li>
                ))}
            </ol>
        </div>
    );
}
